/**
 * Copyright 2025 Paion Data. All rights reserved.
 */

import "./TourRoute.css";
import Footer from "../Footer";
import { StyledHeader } from "./styled";
import BackButton from "./BackButton";

interface TourRouteProps {
  headerImg: string;
  headerLine: string;
  days: Array<{ subHeader: string; header: string; img: string; description: string }>;
}

export default function TourRoute(props: TourRouteProps): JSX.Element {
  return (
    <>
      <StyledHeader $backgroundImg={props.headerImg}>
        <div className="section__container header__container">
          <div className="header__content">
            <h3 className="section__subheader">studytour.io</h3>
            <h1 className="section__header">{props.headerLine}</h1>
            <BackButton />
          </div>
        </div>
      </StyledHeader>
      <section className="about">
        <div className="section__container about__container">
          {props.days.map((day, idx) => (
            <>
              <div className={`about__image about__image-${idx + 1}`}>
                <img src={day.img} alt="about" />
              </div>
              <div className={`about__content about__content-${idx + 1}`}>
                <h3 className="section__subheader">{day.subHeader}</h3>
                <h2 className="section__header">{day.header}</h2>
                <p>{day.description}</p>
                <div className="about__btn">
                  <a href="#">
                    Read more
                    <span>
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </a>
                </div>
              </div>
            </>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
}
